import { Link } from "react-router-dom";
import { APP_ROUTES, USER_TYPES } from "../../../config/constants";
import PrimaryButton from "../../common/PrimaryButton/PrimaryButton";
import UserManagementCard from "./UserManagementCard";

interface UserManagementCardAccessInterface {
  userInfo: any;
  classes: any;
  userDataLoading: any;
  additionalServicesList: any;
  userDialogState: any;
  pageSize: any;
  rowCount: any;
  pageNumber: any;
  fetchNextRecord: any;
}

export const UserManagementCardAccess = (
  props: UserManagementCardAccessInterface
) => {
  const {
    userInfo,
    classes,
    userDataLoading,
    additionalServicesList,
    userDialogState,
    pageSize,
    rowCount,
    pageNumber,
    fetchNextRecord,
  } = props;

  return userInfo?.userProfile?.role !== USER_TYPES.ADMIN &&
    userInfo?.userProfile?.role !== USER_TYPES.READONLY_USER ? (
    <UserManagementCard
      classes={classes}
      userDataLoading={userDataLoading}
      additionalServicesList={additionalServicesList}
      userDialogState={userDialogState}
      pageSize={pageSize}
      rowCount={rowCount}
      pageNumber={pageNumber}
      fetchNextRecord={fetchNextRecord}
    />
  ) : (
    <div className={classes.cardRoot}>
      <div className={classes.accessDiv}>
        <span className={classes.heading}>Access Denied</span>
      </div>
    </div>
  );
};

interface UserAddButtonAccessInterface {
  userInfo: any;
  classes: any;
  handleAddUpdateUserDialogClose: any;
}

export const UserAddButtonAccess = (props: UserAddButtonAccessInterface) => {
  const { userInfo, classes, handleAddUpdateUserDialogClose } = props;
  return userInfo?.userProfile?.role !== USER_TYPES.ADMIN &&
    userInfo?.userProfile?.role !== USER_TYPES.READONLY_USER ? (
    <PrimaryButton
      buttonLabel="CREATE NEW USER"
      buttonVariant="contained"
      onClick={handleAddUpdateUserDialogClose}
      className={classes.buttonStyles}
    />
  ) : (
    <></>
  );
};

interface AddUpdateSubmitUserAccessInterface {
  userInfo: any;
  isUpdatingUser: boolean;
  addUpdateUserStyles: any;
  handleSubmit: any;
  userObj: any;
}

export const AddUpdateSubmitUserAccess = (props: AddUpdateSubmitUserAccessInterface) => {
  const { userInfo, isUpdatingUser, addUpdateUserStyles, handleSubmit, userObj } = props;
  const currentUserRole = userInfo?.userProfile?.role;
  const targetUserRole = userObj?.role;

  const isCurrentUserAdminOrReadOnly = currentUserRole === USER_TYPES.ADMIN || currentUserRole === USER_TYPES.READONLY_USER;
  const isCurrentUserSuperAdmin = currentUserRole === USER_TYPES.SUPER_ADMIN;

  const isTargetUserMafOrSuperAdmin = targetUserRole === USER_TYPES.MAF_ADMIN || targetUserRole === USER_TYPES.SUPER_ADMIN;

  let shouldRenderButton = false;
  if (!isCurrentUserAdminOrReadOnly) {
    if (isCurrentUserSuperAdmin) {
      // If current user is SUPER_ADMIN, they should NOT see the button if the target user is MAF_ADMIN or SUPER_ADMIN
      shouldRenderButton = !(isTargetUserMafOrSuperAdmin);
    } else {
      // If current user is NOT Admin/ReadOnly/SuperAdmin, they should always see the button
      shouldRenderButton = true;
    }
  }

  return shouldRenderButton ? (
    <PrimaryButton
      buttonLabel={isUpdatingUser ? "UPDATE" : "CREATE"}
      buttonVariant="outlined"
      className={addUpdateUserStyles.buttonStyles}
      onClick={handleSubmit}
    />
  ) : (
    null
  );
};

interface EditUserAccessInterface {
  userInfo: any;
  userObj: any;
  userDetailStyles: any;
}

export const EditUserAccess = (props: EditUserAccessInterface) => {
  const { userInfo, userObj, userDetailStyles } = props;
  const currentUserRole = userInfo?.userProfile?.role;
  const targetUserRole = userObj?.role;

  const isCurrentUserAdminOrReadOnly = currentUserRole === USER_TYPES.ADMIN || currentUserRole === USER_TYPES.READONLY_USER;
  const isCurrentUserSuperAdmin = currentUserRole === USER_TYPES.SUPER_ADMIN;

  const isTargetUserMafOrSuperAdmin = targetUserRole === USER_TYPES.MAF_ADMIN || targetUserRole === USER_TYPES.SUPER_ADMIN;

  let shouldRenderEditButton = false;
  if (!isCurrentUserAdminOrReadOnly) {
    if (isCurrentUserSuperAdmin) {
      // If current user is SUPER_ADMIN, they should NOT see the button if the target user is MAF_ADMIN or SUPER_ADMIN
      shouldRenderEditButton = !(isTargetUserMafOrSuperAdmin);
    } else {
      shouldRenderEditButton = true;
    }
  }

  return shouldRenderEditButton ? (
    <Link to={{ pathname: `${APP_ROUTES.USER_MANAGEMENT}`, search: `?userId=${userObj.id}`, }}>
      <PrimaryButton
        buttonLabel="EDIT"
        buttonVariant="outlined"
        className={userDetailStyles.buttonStylesSubmit}
      />
    </Link>
  ) : (
    null
  );
};
